import {SelectBody} from "./SelectBody";
import {DropdownContainer} from "./DropdownContainer";

export class SelectWithInput {
    private container: DropdownContainer | null = null
    private readonly onChange: () => void;
    private inputField: HTMLInputElement;
    private parent: HTMLElement;

    public constructor(dropdownHtml: HTMLElement, onChange: () => void = () => {} ) {
        this.parent = dropdownHtml;
        this.onChange = onChange;
        this.inputField = this.parent.querySelector('input') as HTMLInputElement;
        this.addInputListeners();

        if (dropdownHtml) {
            this.container = new DropdownContainer(
                dropdownHtml,
                () => {
                },
                this.onClickButtonMustToggle.bind(this),
                this.onClickButton.bind(this)
            );
            new SelectBody(
                dropdownHtml.querySelector(".js-wl-checkbox-select-input") as HTMLElement,
                false,
                true,
                this.valueChanged.bind(this)
            );
        }
    }

    private addInputListeners() {
        this.inputField.addEventListener('keyup', (event) => {
            this.formatInputNumber(event.target as HTMLInputElement);
        });
    }

    private formatInputNumber(input: HTMLInputElement) {
        let valueAsNumber = parseInt(input.value.replace(/\D/g, ''), 10);
        if (Number.isNaN(valueAsNumber)) {
            input.value = '';
        } else {
            input.value = valueAsNumber.toLocaleString('es-MX');
        }
    }

    private onClickButtonMustToggle(isOpen: boolean, elementClicked: HTMLElement): boolean {
        return !isOpen || !this.inputHasFocus(elementClicked);
    }

    private onClickButton(isOpen: boolean, elementClicked: HTMLElement) {
        if (!isOpen && !this.inputHasFocus(elementClicked)) {
            this.inputField?.blur();
        }
    }

    private inputHasFocus(element: HTMLElement): boolean {
        return element instanceof HTMLInputElement && element == document.activeElement;
    }

    private valueChanged(selectedValuesText: string[], selectedValues: string[], input: HTMLInputElement | null) {
        this.inputField.value = selectedValues[0];
        this.formatInputNumber(this.inputField);
        this.container!!.close();
        this.onChange();
    }
}
